import { Component } from '@angular/core';
import { BasePrestacaoContaComponent } from 'app/base';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { BaseCrudComponent } from 'app/base';
import { MenuItem } from 'primeng/components/common/menuitem';
import { GrupoAtividade } from '../../entity/enumeraveis';
import { PrestacaoConta } from 'app/entity/prestacao-conta.model';
import * as FileSaver from 'file-saver';
import { cabecalho } from '../../entity/cabecalho-prestacao-conta.model';
import { gridSomatorio } from 'app/entity/grid-Somatorio-prestacao-conta.mode';
import { ResultadoPrestacaoConta } from '../../entity/resultado-prestacao-conta.model';
import { ResultadoPrestacaoContaPontuacao } from 'app/entity/resultado-prestacao-conta-pontuacao.model';
import { FuncaoExercidaPrestacaoConta } from '../../entity/funcao-exercida_prestacao_conta.model';


@Component({
    selector: 'crud-prestacao-conta.component',
    templateUrl: 'crud-prestacao-conta.component.html'
})

export class CrudPrestacaoContaComponent extends BasePrestacaoContaComponent {
    objView: any;
    validateForm: any = false;

    isValid: boolean = false;
    stepObject: any;
    todasHipoteses: any[];
    cabecalhoSomatorio: cabecalho[] = [];
    ano: number = 0;

    listaPontuacao: any[] = [];
    listaPontuacaoTotal: gridSomatorio[] = [];
    listaResutadoFinal: gridSomatorio[] = [];

    profissional: any;

    setStepObject(obj: any) {
        this.stepObject = obj;
    }
    etapas: MenuItem[] = [
        { label: 'Dados Pessoais' },
        { label: 'Atividades' },
        { label: 'Resumo' }
    ];
    cadastro = this.formBuilder.group({
        etapa1: this.formBuilder.group({
            funcao_hipotese: this.formBuilder.group({
                id_funcao_exercida: [null, [Validators.required]],
                id_hipoteses: [null, [Validators.required]],
            }),
            id: [null],
            id_situacao: [16, [Validators.required]],
            id_profissionais: [null],
            data_cadastro: [null]
        }),
        etapa3: this.formBuilder.group({
            aceite: [false, [Validators.required]]
        })
    });

    hipoteses: SelectItem[] = [];
    hipotesesLabel: string = '';

    init() {
        this.service.ListarTodos('hipoteses').subscribe(data => this.todasHipoteses = data);
        this.service.ListarTodos('combo/funcaoExercida').subscribe(data => this.funcaoExercida = data.filter(x => x.data_exclusao == null));
        this.cadastro.get('etapa1.funcao_hipotese.id_hipoteses').disable({ onlySelf: true, emitEvent: true });
        this.cadastro.get('etapa1.funcao_hipotese.id_funcao_exercida').valueChanges.subscribe(data => {
            if (data !== undefined && data !== null && data !== "") {
                this.service.ListarTodos('hipoteses', { id_funcao_exercida: data }).subscribe(data => this.hipoteses = data);
                this.cadastro.get('etapa1.funcao_hipotese.id_hipoteses').setValue(null);
                this.cadastro.get('etapa1.funcao_hipotese.id_hipoteses').enable();
            }
        });
        this.cabecalhoSomatorio.push({ header: "Função Exercida", field: "id_funcao_exercida" });
        this.activatedRoute.params.subscribe(params => {
            let id = params['id'];
            this.service.ListarTodosGenerics("pontuacao/listarPorExercicio", { id: id }).subscribe(retorno => {
                retorno.forEach(item => {
                    let items = new cabecalho;
                    items.header = item.sigla;
                    items.field = item.id;
                    let contem = this.cabecalhoSomatorio.find(x => x.field == items.field);
                    if (contem == undefined) {
                        this.cabecalhoSomatorio.push(items);
                    }
                });
            });

            this.service.ObterTodos('prestacaoConta/buscarTelefonesPrestacao', { idPrestacao: id }).subscribe(x => {
                this.listaTelefones = x;
            })

            this.service.ObterTodos('prestacaoConta/buscarEnderecosPrestacao', { idPrestacao: id }).subscribe(x => {
                this.listaEnderecos = x;
            })

            this.service.ObterTodos('prestacaoConta/buscarEmailsPrestacao', { idPrestacao: id }).subscribe(x => {
                this.listaEmails = x;
            })
        });
    }
    afterLoad() {
        if (this.obj != undefined) {

            //this.verificarAptoPrestarConta();

            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Obter(this.controllerName + "/pesquisarPorCpf", this.obj.cpf).subscribe(retorno => {
                this.profissional = retorno;
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });
            this.idEditar = this.obj.id;
            this.ano = this.obj.exercicio;
            this.listaFuncao = this.obj.funcao_exercida_prestacao_conta;

            // Carrega dados da Aba Atividades
            this.service.ServicoPrestacaoConta(this.controllerName + "/listarPrestacaoConta", this.idEditar, null, this.listaFuncao).subscribe(retorno => {
                this.listaDocencia = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Docencia);
                this.listaSomatorioDocencia = retorno.somatorioDocencia;
                this.listaAquisicaoConhecimento = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Aquisição_de_conhecimento);
                this.listaSomatorioAquisicaoConhecimento = retorno.somatorioAquisicaoConhecimento;

                this.listaAtuacaoComoParticipante = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Atuação_como_participante);
                this.listaSomatorioAtuacaoComoParticipante = retorno.somatorioAtuacaoComoParticipante;

                this.listaProducaoIntelectual = retorno.pontuacaoTodasAtividadeDoProfissional.filter(x => x.id_grupo_atividade == GrupoAtividade.Producao_Intelectual);
                this.listaSomatorioProducaoIntelectual = retorno.somatorioProducaoIntelectual;
                this.listaSomatorioTotal = retorno.somatorioTotal;
            });
        }
    }

//Comentado pois é uma regra que provavelmente vai voltar
    // verificarAptoPrestarConta() {
    //     if (this.acao === 'editar' && this.ehProfissional &&
    //          (this.obj.exercicio == 2019 || this.obj.exercicio == 2020) &&
    //         this.DataSemHora(new Date()) > this.DataSemHora(new Date(2021, 3, 31))) {
    //         this.showMsgWarn(`A data limite para prestar contas do ano de ${this.obj.exercicio} é 31/03/2021`);
    //         this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    //     }
    //     else if (this.acao === 'editar' && this.ehProfissional &&
    //          (this.obj.exercicio != 2019 && this.obj.exercicio != 2020) &&
    //         this.DataSemHora(new Date()) > this.DataSemHora(new Date(this.obj.anoExercicio + 1, 1, 31))) {
    //         this.showMsgWarn(`A data limite para prestar contas do ano de ${this.obj.exercicio} é 31/01/${this.obj.exercicio + 1}`);
    //         this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/app/prestacao-conta/crud/crud-prestacao-conta.component.ts